import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, map, Subscription, switchMap, tap } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../../shared/dialog/confirm-modal/confirm-dialog.component';
import { LocalStorageService } from 'ngx-webstorage';
import { NotificationService } from '../../services/notification.service';
import { SpinnerComponent } from '../spinner/spinner.component';
import { SpinnerService } from '../../services/spinner.service';

@Component({
  selector: 'ngb-main-container',
  templateUrl: './main-container.component.html',
  styleUrl: './main-container.component.scss',
  imports: [
    SharedModule,
    RouterOutlet,
    SpinnerComponent
  ],
})
export class MainContainerComponent implements OnInit,OnDestroy{

   currentUrl: string;

  //TODO: dati mock
  profile = signal<any>({
    id: '1',
    name: 'User',
    surname: 'Prova',
    email: 'user.p@gmail.com',
    cf: 'cccc333ggg333',
    status:'ACTIVE',
    permissions: ['ALL','READ','WRITE'],
  });

  badgeNumber = signal<number>(0);

  private _currentUrlSubscription: Subscription = new Subscription();
  private readonly _router: Router = inject( Router);
  private readonly dialog:MatDialog = inject(MatDialog);
  private readonly _storage:LocalStorageService = inject(LocalStorageService);
  private readonly _notificationService :NotificationService = inject(NotificationService);
  private readonly _spinnerService: SpinnerService = inject(SpinnerService);

  get loading(): boolean {
    return this._spinnerService.loading;
  }
  
  get isLogin(): boolean {
    return this.currentUrl?.includes('login');
  }

  get isRegistration(): boolean {
    return this.currentUrl?.includes('registration');
  }

  get isErrorPage(): boolean {
    return this.currentUrl?.includes('error-page');
  }

  get isAuthenticated(): boolean {
  return !!this._storage.retrieve('token');
  }

  get isDashboard():boolean {
    return this.currentUrl?.includes('dashboard');
  }

  ngOnInit(): void {
    this._currentUrlSubscription = this._router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(event => event.urlAfterRedirects),
      tap(currentUrl => this.currentUrl = currentUrl),
      filter(() => !this.isLogin), 
      switchMap(()=> this._notificationService.getBadgeNumber()),
      tap(number => this.badgeNumber.set(number))
    ).subscribe();
  }

  ngOnDestroy(): void {
    this._currentUrlSubscription.unsubscribe();
  }

  onLogout(){
    this.dialog.open(ConfirmDialogComponent ,{
      width: '400px',
      disableClose: true,
      data : {
        title:'Attenzione',
        message:`Sei sicuro di voler effettuare il logout ?`
      },
    }).afterClosed().subscribe(result => {
      if (result.confirmed === true) {
        this._storage.clear();
        this._router.navigate(['login']);
      } 
    })
  }


}
